module.exports = __webpack_public_path__ + "img/2.7fb2e7ea.png";